
















































































































import IconButton from "../../../components/IconButton.vue";
import Vue from "vue";
import Fragment from "../../../components/Fragment.vue";
import { StoreIn, getRelationState, ExtOrder, InvoiceRelationState } from "../models";
import store, { InvoiceItemStore } from "../services/store";
import StockTable from "./StockTable.vue";
import RelationStateBadge from "./RelationStateBadge.vue";
import StoreInFees from "./StoreInFees.vue";
import AddItemButton from "./AddItemButton.vue";
import OthersTable from "./OthersTable.vue";
import eventBus from "@/services/eventBus";
import Configuration, { AppConfiguration } from "@/models/Configuration";
import flowStore, { InvoiceFlowStore } from "@/modules/invoiceFlow/services/InvoiceFlowStore";
import { t } from "@/plugins/i18n";

interface Data {
  store: InvoiceItemStore;
  flowStore: InvoiceFlowStore;
  configuration: AppConfiguration;
  warningMsg: string;
}

interface PreProcessInfo {
  icon: string;
  color: string;
  text: string;
}

interface Props {
  title: string;
  items: StoreIn[];
}

interface Computed {
  hasData: boolean;
  currency: string;
  visibleItems: StoreIn[];
  optionalColumns: Set<string>;
  preProcessInfoVisible: boolean;
}

interface Methods {
  toggleDetails(storeIn: StoreIn): void;
  getRelationState(item: StoreIn | ExtOrder): InvoiceRelationState;
  getOrderNumber(storeIn: StoreIn): string | undefined;
  addStoreIn(items: StoreIn): void;
  orderNumberOrHyphen(items: StoreIn): string;
  preProcessInfo(storeIn: StoreIn): PreProcessInfo;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Fragment,
    StockTable,
    IconButton,
    RelationStateBadge,
    StoreInFees,
    AddItemButton,
    OthersTable,
  },

  data: () => ({
    store,
    flowStore,
    configuration: Configuration,
    warningMsg: "",
  }),

  props: {
    items: {
      type: Array as () => StoreIn[],
    },

    title: {
      type: String,
      default: t("InvoiceItems_BetarolasTalalatok"),
    },
  },

  computed: {
    hasData() {
      return this.items && this.items.length > 0;
    },

    currency() {
      return this.store.currency;
    },

    visibleItems() {
      return this.items.filter((i) => this.store.selectedStateOption === getRelationState(i));
    },

    // az előfeldolgozás jelzése csak akkor releváns, ha a kereső tényleg a legyártott készletre szűr
    preProcessInfoVisible() {
      return this.flowStore.invoice.prodPurchase && this.configuration.sysParams.geniStinProdSearch;
    },

    optionalColumns() {
      const columns = new Set<string>();

      if (!this.hasData) {
        return columns;
      }

      if (this.visibleItems.some((i) => !!this.getOrderNumber(i))) {
        columns.add("orderNumber");
      }

      return columns;
    },
  },

  methods: {
    orderNumberOrHyphen(item: StoreIn) {
      if (!item.stocks || item.stocks.length == 0) {
        return "-";
      }
      if (item.stocks[0].orderNumber == item.stocks[item.stocks.length - 1].orderNumber) {
        return item.stocks[0].orderNumber;
      }
      return "-";
    },

    async addStoreIn(item: StoreIn) {
      this.store.addStoreIn(item);
      if (Configuration.operel) return;
      await this.store.searchTrumesServices(item);
      await this.store.searchCreditingStorein(item);

      await this.store.searchReturnOrder(item);
      await this.store.save();
    },

    // felvásárlási jegynél jelezzük, hogy a betárolás átesett-e a leválogatáson
    preProcessInfo(storeIn: StoreIn) {
      if (storeIn.isPreProcessed === false) {
        return {
          icon: "fa-exclamation-circle",
          color: "secondary",
          text: t("InvoiceItems_EzABetarolasMegNemEsett"),
        };
      }

      return {
        icon: "fa-cubes",
        color: "secondary",
        text: t("InvoiceItems_EzABetarolasMarAtesettAz"),
      };
    },

    getRelationState,
    toggleDetails(storeIn: StoreIn) {
      storeIn.expanded = !storeIn.expanded;
    },

    getOrderNumber(storeIn: StoreIn) {
      const stock = (storeIn.stocks || []).find((s) => s.orderNumber);
      if (stock) {
        return stock.orderNumber;
      }

      return undefined;
    },
  },
});
